import { ajaxPostJson, setParams } from './ajax';
//获取任务数量
// export const taskNumber = (params) => {
//     return ajaxPostJson(`/fileTask/countUserFinishWordNum`, params,'BaseApi');
// };
// //获取任务列表
// export const getTaskPage = (params) => {
//   params.filter=setParams(params.filter)
//     return ajaxPostJson(`/fileTask/query_page/my_task`, params,'BaseApi');
// };
// //获取任务数量
// export const getTaskNum = (params) => {
//     params = setParams(params);
//     return ajaxPostJson(`/fileTask/userIdToTaskClassificationNum`, params,'BaseApi');
// };

//获取分页
export const queryPage = (params) => {
  params.filter = setParams(params.filter);
  return ajaxPostJson(`/file/queryPage`, params);
};

//删除文件
export const deleteFile = (params) => {

  return ajaxPostJson(`/file/batchDeleteFiles`, params);
};
//获取筛选数据
export const filterData = (params) => {
  return ajaxPostJson(`/file/getBrushSelectionCriteriaList`, params);
};

//获取原文译文
export const originalTranslation = (params) => {
  return ajaxPostJson(`/file/loadEditSentTagPairFileByPage`, params);
};
//获取文档翻译历史查询
export const queryDocumentTranslationPage = (params) => {
  params.filter = setParams(params.filter);
  return ajaxPostJson(`/file/queryDocumentTranslationPage`, params);
};
// 文件搜索
export const searchFile = (params) => {
  params.filter = setParams(params.filter);
  return ajaxPostJson(`/search/searchFile`, params);
};